import { getChromeOmnibox } from '../chrome/wrappers';
import { fullOnboardingWithCredentials } from '../onboarding/authentication';

const LOGIN_COMMAND = 'login';

/**
 * Initialize the debug command functionality.
 */
export const setupDebugConsole = () => {
  setDefaultSuggestion();
  provideSuggestions();
  listenCommands();
};

/**
 * Set default suggestion.
 */
const setDefaultSuggestion = () => {
  getChromeOmnibox().setDefaultSuggestion({
    description:
      'Welcome to the Qustodio debug console! Begin typing your command to start. <dim>Available commands: login</dim>',
  });
};

/**
 * Suggest available debug commands to the user.
 */
const provideSuggestions = () => {
  getChromeOmnibox().onInputChanged.addListener(function (_text, suggest) {
    suggest([
      {
        content: `${LOGIN_COMMAND} youremail@example.com "yourpassword" "Device Name" "Profile Name"`,
        description:
          "Login <dim>Any matching devices/profiles will be created if they don't exist. Use double-quotes for device/profile names with spaces.</dim>",
      },
    ]);
  });
};

/**
 * Listen debug commands and execute them.
 */
const listenCommands = () => {
  getChromeOmnibox().onInputEntered.addListener(input => {
    const commandArgs = splitCommandArgs(input);
    const command = commandArgs[0];
    const params = commandArgs.slice(1);
    if (command === LOGIN_COMMAND) {
      return login(params);
    }
    return console.error(`The command ${command} does not exist!`);
  });
};

/**
 * Return array with command and args that are separated by spaces.
 *
 * All strings inside double quotes will be treated as one entity.
 *
 * E.g. command arg1 arg2 "arg 3" would return ["command", "arg1", "arg2", "arg 3"]
 */
const splitCommandArgs = (command: string): string[] => {
  const regex = /[^\s"']+|"([^"]*)"|'([^']*)'/g;
  const matches = command.match(regex);

  if (!matches) {
    return [];
  }

  // Remove surrounding quotes from matched strings
  return matches.map(match =>
    match.startsWith('"') && match.endsWith('"') ? match.slice(1, -1) : match
  );
};

/**
 * Validate if the number of provided arguments is correct.
 *
 * @param expectedExtraParams - Number of expected params (E.g. For `command param1 param2 param3` it would be 3)
 * @param args - Array of arguments (command + extra params)
 */
const validateArguments = (expectedExtraParams: number, args: string[]) => {
  if (args.length !== expectedExtraParams) {
    console.error('Incorrect number of arguments!');
    return false;
  }
  return true;
};

const login = (args: string[]) => {
  if (validateArguments(4, args)) {
    const user = args[0];
    const password = args[1];
    const deviceName = args[2];
    const profileName = args[3];
    return fullOnboardingWithCredentials(
      user,
      password,
      deviceName,
      profileName
    );
  }
};
